import { FC } from 'react';

type Props = {
	className?: string;
};

const MoveLeftIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M3.33301 9.99976H16.6663'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M7.49965 14.1666C7.49965 14.1666 3.33302 11.0979 3.33301 9.99992C3.333 8.90192 7.49967 5.83325 7.49967 5.83325'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default MoveLeftIcon;
